export default {
	TABLE_TITLE: 'Shift transfer policies',
	SHIFT_TRANSFER_POLICY_ADDED: 'Shift transfer policy added',
	SHIFT_TRANSFER_POLICY_EDITED: 'Shift transfer policy edited',
	SHIFT_TRANSFER_POLICY_DELETED: 'Shift transfer policy deleted',

	MARKETS_TABLE_TITLE: 'Markets',
};
